module.exports = [
  {
    name: 'Walmart, Inc.',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/162'
  },
  {
    name: 'Amazon.com, Inc.',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/69'
  },
  {
    name: 'Allied Universal',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/193'
  },
  {
    name: 'US Navy',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/476'
  },
  {
    name: 'FedEx Corporation',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/442'
  },
  {
    name: 'Home Depot',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/313'
  },
  {
    name: "McDonald's",
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/594'
  },
  {
    name: 'Kroger',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/82'
  },
  {
    name: 'Berkshire Hathaway',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/371'
  },
  {
    name: 'IBM',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/374'
  },
  {
    name: 'United Parcel Service',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/495'
  },
  {
    name: 'Target Corporation',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/406'
  },
  {
    name: 'Lowes',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/28'
  },
  {
    name: 'Uber',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/33'
  },
  {
    name: 'Citigroup',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/450'
  },
  {
    name: 'UnitedHealth Group',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/254'
  },
  {
    name: 'Deloitte',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/92'
  },
  {
    name: 'Boeing',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/160'
  },
  {
    name: "Arby's",
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/45'
  },
  {
    name: 'Walgreens Boots Alliance',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/667'
  },
  {
    name: 'TJX',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/119'
  },
  {
    name: 'Dell Technologies',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/608'
  },
  {
    name: 'Comcast',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/559'
  },
  {
    name: 'Oracle',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/403'
  },
  {
    name: 'Bank of America',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/624'
  },
  {
    name: 'Panera Bread',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/244'
  },
  {
    name: 'AT&T',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/619'
  },
  {
    name: 'HCA Healthcare',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/598'
  },
  {
    name: 'Raytheon Technologies',
    bannerLogoUrl:
      'https://res.cloudinary.com/http-collegerecruiter-com/image/upload/c_fill/banner/23'
  }
];
